// Admin Pages (CMS)
export default function AdminPages() { return <div><h1 className="text-3xl font-bold">Pages (CMS)</h1><p className="mt-4">Manage website pages with block editor and Puck.js visual builder.</p></div>; }